import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { Box, Divider } from "@mui/material";

function SocialActivityList() {
  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] m-auto pt-[90px] page-title">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">得獎紀錄</h2>
            <h3 className="text-[#696969] font-normal text-xl" style={{ color: "#ff6b2b" }}>
              Reward Record
            </h3>
          </div>
        </section>
        <section className="max-w-[1300px] m-auto pt-[10px] mb-16">
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img
                src="http://cdn.asiamc.com.tw/iafMie9VfzuqXDYnM3tiPk.jpg"
                alt=""
                className="border-8 border-white shadow-2xl"
              />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[25px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                2010/10/01 呂秀蓮合影-金峰獎
              </p>
            </Box>
          </Box>
          <Divider />
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img
                src="http://cdn.asiamc.com.tw/BCXeVxs5VRipExbJ5rrj85.jpg"
                alt=""
                className="border-8 border-white shadow-2xl"
              />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[15px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                2020/03/01 洪馬內合影
              </p>
            </Box>
            ˊ
          </Box>
          <Divider />
          <Box className="my-[10px]" display="flex" width="100%">
            <Box className="pl-[50px] pr-[30px] pt-[20px] pb-[20px]" width="50%">
              <img
                src="http://cdn.asiamc.com.tw/9keEMbNM8SGYXzZxhgR6Lc.jpg"
                alt=""
                className="border-8 border-white shadow-2xl"
              />
            </Box>
            <Box className="pl-[30px] pr-[50px] pt-[30px] pb-[30px]" width="50%">
              <p
                className="pb-[15px]"
                style={{ fontSize: "30px", color: "#A93230", fontWeight: 400 }}
              >
                2020/03/28 頒發柬埔寨華商投資協會台灣分會會長證書
              </p>
            </Box>
          </Box>
          <Divider />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default SocialActivityList;
